import type React from "react";

import type { ProgressBarProps } from "./ProgressBar.model";
import { BoxProgress, Container, StyleLineProgress, StyleProgress } from "./ProgressBar.styled";

export const ProgressBar: React.FC<ProgressBarProps> = ({ total, progress }) => (
  <Container>
    <StyleProgress>
      <BoxProgress>{progress}</BoxProgress>
      <StyleLineProgress progress={(progress * 100) / total} />
    </StyleProgress>
    <p>{total}</p>
  </Container>
);
